'use client';

import React from "react";

const GTM_ID = 'GTM-TFKVPCV';

const GoogleTagManagerNoscript = () => {
  return (
    <noscript>
      <iframe
        title="GoogleTagManagerNoscript"
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  );
};

export default GoogleTagManagerNoscript;